import React, { useState } from "react";
import "./FranchiseForm.css"; // ✅ keep your same CSS

export default function FranchiseForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // ✅ WhatsApp redirect logic
    const phoneNumber = "919152023390"; // Your WhatsApp number (without +)
    const message = `🌞 *Franchise Partner Inquiry* 🌞

*Name:* ${formData.name}
*Email:* ${formData.email}
*Mobile:* ${formData.mobile}

I'm interested in becoming a Franchise Partner. Please contact me.`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");

    setFormData({ name: "", email: "", mobile: "" }); // Reset form
  };

  return (
    <section className="franchise-section">
      <div className="container">
        <div className="franchise-content">
          <div className="franchise-text">
            <h2>Become a Franchise Partner</h2>
            <p>Join us in powering a sustainable future with solar energy!</p>
          </div>

          <form className="franchise-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Full Name..."
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email Here..."
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="mobile"
              placeholder="Mobile Number..."
              value={formData.mobile}
              onChange={handleChange}
              required
            />
            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </section>
  );
}
